// src/pages/ReserveEdit.js
import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import './ReserveEdit.scss';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import api from '../Axios/axios';

const ReserveEdit = () => {
  const { reserveId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const reserveFromState = location.state?.reserve || null;
  const craneFromState = location.state?.crane || null;
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [actionError, setActionError] = useState('');
  const [actionSuccess, setActionSuccess] = useState('');

  const [reserveDetails, setReserveDetails] = useState({
      id: 0,
  rentingCompanyId: '',
  towerCraneId: 0,
  workSiteId: 0,
    craneOwner: '',
    serialNo: '',
    brand: '',
    craneCode: '',
    height: '',
    maxTonnage: '',
    rentalCompany: '',
    site: '',
    chassisType: '',
    walkingSystem: '',
    installationHeight: '',
    JibLength:'',
    rentalDuration: '',
    rentalFee: '',
    startDate: '',
    endDate: '',
    hasExtraPeriod: false,
    extraPeriod: 0,
    notes: [{ id: 1, note: '' }],
  });
  const [files, setFiles] = useState(() => reserveFromState?.files || []);
  const [warehouses, setWarehouses] = useState([]);
  const [newDepotName, setNewDepotName] = useState('');
  const [newDepotAddress, setNewDepotAddress] = useState('');

  const getErrorMessage = (err, fallbackMessage) => {
    const data = err?.response?.data;
    if (!data) {
      return err?.message || fallbackMessage;
    }

    if (Array.isArray(data?.messages) && data.messages.length > 0) {
      return data.messages.join(' ');
    }

    if (typeof data?.message === 'string' && data.message.trim()) {
      return data.message;
    }

    if (typeof data?.title === 'string' && data.title.trim()) {
      const validationErrors = data?.errors && typeof data.errors === 'object'
        ? Object.values(data.errors).flat().join(' ')
        : '';
      return `${data.title}${validationErrors ? ` ${validationErrors}` : ''}`.trim();
    }

    try {
      return JSON.stringify(data);
    } catch {
      return fallbackMessage;
    }
  };

  const appendIfHasValue = (formData, key, value) => {
    if (value === null || value === undefined || value === '') {
      return;
    }
    formData.append(key, value);
  };

  // 1) Rezerv ve Vinç verisini al
  useEffect(() => {
    if (!reserveFromState) return;

    const notes = reserveFromState.notes && reserveFromState.notes.length > 0
      ? reserveFromState.notes
      : [{ id: 1, note: '' }];

    setReserveDetails((prev) => ({
      ...prev,
      id: reserveFromState.id,
      rentingCompanyId: reserveFromState.rentingCompanyId,
      towerCraneId: reserveFromState.towerCraneId,
      workSiteId: reserveFromState.workSiteId,
      craneOwner: reserveFromState.owner || prev.craneOwner,
      serialNo: craneFromState?.serialNo || prev.serialNo,
      brand: craneFromState?.brand || prev.brand,
      craneCode: craneFromState?.model || prev.craneCode,
      height: craneFromState?.height || prev.height,
      maxTonnage: craneFromState?.maxTonnage || prev.maxTonnage,
      rentalCompany: reserveFromState.rentingCompany || prev.rentalCompany,
      site: reserveFromState.workSite || prev.site,
      chassisType: (reserveFromState.type || craneFromState?.type) === 'Chassis' ? 'Şaseli' : 'Ankarajlı',
      walkingSystem: (reserveFromState.hasWalkingGear ?? craneFromState?.hasWalkingGear) ? 'Var' : 'Yok',
      installationHeight: reserveFromState.installedHeight || prev.installationHeight,
      JibLength: reserveFromState.jibLength || prev.JibLength,
      rentalDuration: reserveFromState.rentalPeriod || prev.rentalDuration,
      rentalFee: reserveFromState.rent || prev.rentalFee,
      startDate: reserveFromState.reserveStartDate?.split('T')[0]
        ?? reserveFromState.rentalStartDate?.split('T')[0]
        ?? prev.startDate,
      endDate: reserveFromState.reserveEndDate?.split('T')[0]
        ?? reserveFromState.rentalEndDate?.split('T')[0]
        ?? prev.endDate,
      hasExtraPeriod: reserveFromState.hasExtraPeriod || false,
      extraPeriod: reserveFromState.extraPeriod || 0,
      notes,
    }));

    setFiles(reserveFromState.files || []);
  }, [reserveFromState, craneFromState]);

useEffect(() => {
  const fetchData = async () => {
    try {
      // 1) Tüm rezerveleri al
      const resAll = await api.get('/Reserve');
      const allReserves = resAll.data.data;
      console.log('>> All Reserves:', allReserves);

      // 2) URL parametresine (reserveId) göre doğru rezervi bul
      const r = allReserves.find(item => item.id.toString() === reserveId);
      if (!r) {
        console.error(`Rezerv bulunamadı: ${reserveId}`);
        return;
      }
      console.log('>> Selected Reserve:', r);

      // 3) O rezerv için vinç detayını al
      let c = {};
      try {
        const craneRes = await api.get(`/TowerCrane/GetById?id=${r.towerCraneId}`);
        c = craneRes?.data?.data || {};
        console.log('>> Crane GET:', c);
      } catch (craneError) {
        console.error('Vinç detayı alınamadı, rezerv verisi ile devam ediliyor:', craneError);
      }
      let notes = r.notes && r.notes.length > 0
        ? r.notes
        : [{ id: 1, note: '' }];


      // 4) state’i doldur
      setReserveDetails({
          id:                  r.id,
        rentingCompanyId:    r.rentingCompanyId,
        towerCraneId:        r.towerCraneId,
        workSiteId:          r.workSiteId,
        craneOwner:       r.owner               || '',
        serialNo:         c.serialNo            || '',
        brand:            c.brand               || '',
        craneCode:        c.model               || '',
        height:           c.height              || '',
        maxTonnage:       c.maxTonnage          || '',
        rentalCompany:    r.rentingCompany      || '',
        site:             r.workSite            || '',
        chassisType:      (r.type || c.type) === 'Chassis' ? 'Şaseli' : 'Ankarajlı',
        walkingSystem:    (r.hasWalkingGear ?? c.hasWalkingGear) ? 'Var' : 'Yok',
        installationHeight: r.installedHeight    || '',
        JibLength:        r.jibLength            || '',
        rentalDuration:   r.rentalPeriod        || '',
        rentalFee:        r.rent                || '',
        startDate:        r.reserveStartDate?.split('T')[0]
                          ?? r.rentalStartDate?.split('T')[0]
                          ?? '',
        endDate:          r.reserveEndDate?.split('T')[0]
                          ?? r.rentalEndDate?.split('T')[0]
                          ?? '',
        hasExtraPeriod:   r.hasExtraPeriod      || false,
        extraPeriod:      r.extraPeriod         || 0,
        notes:            notes,
      });

      setFiles(r.files || []);
    } catch (err) {
      console.error('Veri çekme hatası:', err);
    }
  };

  if (reserveId) {
    fetchData();
  }
}, [reserveId]);


  // 2) Depo listesini al (gerekirse)
  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const resp = await api.get('/Warehouse');
        setWarehouses(resp.data.data);
      } catch (err) {
        console.error('Depolar yüklenemedi:', err);
      }
    };
    fetchWarehouses();
  }, []);

  // 3) Bitiş tarihini otomatik hesapla
  useEffect(() => {
    if (!reserveDetails.startDate) return;
    const months = parseInt(reserveDetails.rentalDuration, 10) || 0;
    const extraDays = reserveDetails.hasExtraPeriod ? parseInt(reserveDetails.extraPeriod, 10) || 0 : 0;
    const dt = new Date(reserveDetails.startDate);
    dt.setMonth(dt.getMonth() + months);
    dt.setDate(dt.getDate() + extraDays);
    setReserveDetails((p) => ({ ...p, endDate: dt.toISOString().split('T')[0] }));
  }, [
    reserveDetails.startDate,
    reserveDetails.rentalDuration,
    reserveDetails.hasExtraPeriod,
    reserveDetails.extraPeriod,
    
    
  ]);

  // 4) Input değişimleri
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setReserveDetails((p) => ({
      ...p,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // 5) Not ekleme/güncelleme
  const handleNoteChange = (i, val) => {
    const nn = [...reserveDetails.notes];
    nn[i].note = val;
    setReserveDetails((p) => ({ ...p, notes: nn }));
  };
  const addNote = () => {
    setReserveDetails((p) => ({
      ...p,
      notes: [...p.notes, { id: p.notes.length + 1, note: '' }],
    }));
  };

  // 6) Dosya yükleme
  const handleFileChange = (e, fileType) => {
    const arr = Array.from(e.target.files).map((f) => ({
      id: 0,
      fileType,
      file: [f],
      fileName: f.name,
    }));
    setFiles((p) => [...p, ...arr]);
  };

  // 7) Kiraya dönüştür
const handleConvertToRental = async () => {
  try {
    setActionError('');
    setActionSuccess('');
    // Swagger’daki JSON şemasına birebir uyan payload
    const payload = {
      id:                 parseInt(reserveId,      10),
      rentingCompanyId:   reserveDetails.rentingCompanyId,
      rentingMachineCompanyId: null,
      towerCraneId:       reserveDetails.towerCraneId,
      workSiteId:         reserveDetails.workSiteId,
      installedHeight:    parseInt(reserveDetails.installationHeight, 10) || 0,
      jibLength:          parseInt(reserveDetails.JibLength, 10) || 0,
      type:               reserveDetails.chassisType === 'Şaseli' ? 'Chassis' : 'Anchored',
      hasWalkingGear:     reserveDetails.walkingSystem === 'Var',
      rentalPeriod:       parseInt(reserveDetails.rentalDuration, 10) || 0,
      hasExtraTime:       !!reserveDetails.hasExtraPeriod,
      extraPeriod:        reserveDetails.hasExtraPeriod ? (parseInt(reserveDetails.extraPeriod, 10) || 0) : 0,
      extraPeriodMonth:   0,
      rent:               parseFloat(reserveDetails.rentalFee) || 0,
      rentalStartDate:    reserveDetails.startDate,   // "YYYY-MM-DD"
      rentalEndDate:      reserveDetails.endDate      // "YYYY-MM-DD"
    };

    await api.put('/Reserve/Done', payload);
    setActionSuccess('Rezerve kaydı başarıyla kiraya gönderildi.');
    navigate('/grouptracking');
  } catch (err) {
    console.error('Kiraya dönüştürme hatası:', err.response?.data || err);
    const errorMessage = getErrorMessage(err, 'Kiraya gönderme işlemi başarısız oldu.');
    setActionError(errorMessage);
  }
};


  // 8) Rezerveyi güncelle
const handleReserveUpdate = async () => {
  try {
    setActionError('');
    setActionSuccess('');
    // FormData ile multipart/form-data oluştur
    const formData = new FormData();
    formData.append('Id', reserveDetails.id);
    formData.append('RentingCompanyId', reserveDetails.rentingCompanyId);
    formData.append('TowerCraneId', reserveDetails.towerCraneId);
    appendIfHasValue(formData, 'WorkSiteId', reserveDetails.workSiteId);
    appendIfHasValue(formData, 'InstalledHeight', reserveDetails.installationHeight);
    appendIfHasValue(formData, 'JibLength', reserveDetails.JibLength);
    formData.append('Type', reserveDetails.chassisType === 'Şaseli' ? 'Chassis' : 'Anchored');
    appendIfHasValue(formData, 'HasWalkingGear', reserveDetails.walkingSystem === 'Var');
    appendIfHasValue(formData, 'RentalPeriod', reserveDetails.rentalDuration);
    formData.append('HasExtraTime', reserveDetails.hasExtraPeriod);
    appendIfHasValue(formData, 'ExtraPeriod', reserveDetails.extraPeriod);
    appendIfHasValue(formData, 'ExtraPeriodMonth', 0);
    appendIfHasValue(formData, 'Rent', reserveDetails.rentalFee);
    appendIfHasValue(formData, 'RentalStartDate', reserveDetails.startDate);
    appendIfHasValue(formData, 'RentalEndDate', reserveDetails.endDate);

    // Dosyaları ekle (Files alanı dizi olarak geliyor)
    files.forEach((fileObj, index) => {
      if (fileObj.id) {
        formData.append(`Files[${index}].Id`, fileObj.id);
      }
      if (fileObj.file && fileObj.file.length > 0 && typeof fileObj.file[0] !== 'string') {
        formData.append(`Files[${index}].File`, fileObj.file[0]);
      }
      formData.append(`Files[${index}].FileType`, fileObj.fileType);
    });

    // Notları JSON string olarak ekle
reserveDetails.notes.forEach((item, idx) => {
  formData.append(`Notes[${idx}]`, item.note);
});

    await api.put('/Reserve', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    setActionSuccess('Rezerve kaydı başarıyla güncellendi.');
    window.location.reload();
  } catch (err) {
    console.error('Rezerve güncelleme hatası:', err.response?.data || err);
    const errorMessage = getErrorMessage(err, 'Rezerveyi güncelleme başarısız oldu.');
    setActionError(errorMessage);
  }
};




  // 9) Rezerveyi iptal et
  const handleReserveCancel = async () => {
    try {
    setActionError('');
    setActionSuccess('');
    await api.delete(`/Reserve/${reserveId}`);
      setActionSuccess('Rezerve kaydı başarıyla iptal edildi.');
      navigate('/grouptracking');
    } catch (err) {
      console.error(err.response?.data || err);
      const errorMessage = getErrorMessage(err, 'Rezerveyi iptal etme başarısız oldu.');
      setActionError(errorMessage);
    }
  };

  return (
    <div className="rental-edit-page">
      <Navbar />
      <div className="rental-form">
        <h2>Rezerve Düzenle</h2>
        {actionError && <div className="technical-service-alert error">{actionError}</div>}
        {actionSuccess && <div className="technical-service-alert success">{actionSuccess}</div>}

        <div className="form-row">
          <div className="form-group">
            <label>Kule Vinç Sahibi Firma</label>
            <input
              type="text"
              name="craneOwner"
              value={reserveDetails.craneOwner}
              disabled
              readOnly
            />
          </div>
        </div>

        <div className="form-row craneinfos">
          <label><b>Seri No:</b> {reserveDetails.serialNo}</label>
          <label><b>Marka:</b> {reserveDetails.brand}</label>
          <label><b>Model:</b> {reserveDetails.craneCode}</label>
          <label><b>Yükseklik:</b> {reserveDetails.height} m</label>
          <label><b>Tonaj:</b> {reserveDetails.maxTonnage}T</label>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Rezerve Eden Firma</label>
            <input
              type="text"
              name="rentalCompany"
              value={reserveDetails.rentalCompany}
              disabled
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Şantiye/Depo</label>
            <input
              type="text"
              name="site"
              value={reserveDetails.site}
              disabled
              readOnly
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Şaseli mi?</label>
            <select
              name="chassisType"
              value={reserveDetails.chassisType}
            >
              <option value="">Seçin</option>
              <option value="Şaseli">Şaseli</option>
              <option value="Ankarajlı">Ankarajlı</option>
            </select>
          </div>
          <div className="form-group">
            <label>Yürüyüş Takımı Var mı?</label>
            <select
              name="walkingSystem"
              value={reserveDetails.walkingSystem}
              
            >
              <option value="">Seçin</option>
              <option value="Var">Var</option>
              <option value="Yok">Yok</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Kurulum Yüksekliği (m)</label>
            <input
              type="number"
              name="installationHeight"
              value={reserveDetails.installationHeight}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
                <label>Kaç Metre Bomda Kuruluyor?</label>
                <input type="number" name="JibLength" value={reserveDetails.JibLength} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Kira Süresi (Ay)</label>
            <input
              type="number"
              name="rentalDuration"
              value={reserveDetails.rentalDuration}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Kira Bedeli (TL)</label>
            <input
              type="number"
              name="rentalFee"
              value={reserveDetails.rentalFee}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Rezerve Başlangıç Tarihi</label>
            <input
              type="date"
              name="startDate"
              value={reserveDetails.startDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Rezerve Bitiş Tarihi</label>
            <input
              type="date"
              name="endDate"
              value={reserveDetails.endDate}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row checkbox-group">
          <label>Uzatma Süresi Var mı?</label>
          <input
            type="checkbox"
            name="hasExtraPeriod"
            checked={reserveDetails.hasExtraPeriod}
            onChange={handleChange}
          />
        </div>

        {reserveDetails.hasExtraPeriod && (
          <div className="form-row">
            <div className="form-group">
              <label>Uzatma Süresi (Gün)</label>
              <input
                type="number"
                name="extraPeriod"
                value={reserveDetails.extraPeriod}
                onChange={handleChange}
              />
            </div>
          </div>
        )}

        {/* Dosya Yükleme Alanları */}
        <div className="form-row">
          <div className="form-group">
            <label>Teklif Dosyası</label>
            <input type="file" multiple onChange={(e) => handleFileChange(e, 'Offer')} />
            <div className="file-names">
              {files.filter(f => f.fileType === 'Offer').map((f, i) => (
                <div key={i} className="file-name">
                  {i + 1}. {f.fileName}
                </div>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label>Sözleşme Dosyası</label>
            <input type="file" multiple onChange={(e) => handleFileChange(e, 'Contract')} />
            <div className="file-names">
              {files.filter(f => f.fileType === 'Contract').map((f, i) => (
                <div key={i} className="file-name">
                  {i + 1}. {f.fileName}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Servis Formu</label>
            <input type="file" multiple onChange={(e) => handleFileChange(e, 'ServiceForm')} />
            <div className="file-names">
              {files.filter(f => f.fileType === 'ServiceForm').map((f, i) => (
                <div key={i} className="file-name">
                  {i + 1}. {f.fileName}
                </div>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label>Görseller</label>
            <input type="file" accept="image/*" multiple onChange={(e) => handleFileChange(e, 'Image')} />
            <div className="file-names">
              {files.filter(f => f.fileType === 'Image').map((f, i) => (
                <div key={i} className="file-name">
                  {i + 1}. {f.fileName}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Ödeme Dekontu</label>
            <input type="file" multiple onChange={(e) => handleFileChange(e, 'paymentDoc')} />
            <div className="file-names">
              {files.filter(f => f.fileType === 'paymentDoc').map((f, i) => (
                <div key={i} className="file-name">
                  {i + 1}. {f.fileName}
                </div>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label>Çek Görselleri</label>
            <input type="file" multiple onChange={(e) => handleFileChange(e, 'checkImages')} />
            <div className="file-names">
              {files.filter(f => f.fileType === 'checkImages').map((f, i) => (
                <div key={i} className="file-name">
                  {i + 1}. {f.fileName}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Notlar */}
        <div className="form-row notes-container">
          {reserveDetails.notes.map((note, idx) => (
            <div key={idx} className="form-group note-group">
              <label>Not {idx + 1}</label>
              <input
                type="text"
                value={note.note}
                onChange={e => {
                  const nn = [...reserveDetails.notes];
                  nn[idx].note = e.target.value;
                  setReserveDetails(p => ({ ...p, notes: nn }));
                }}
              />
            </div>
          ))}
          <button
            type="button"
            className="add-note-btn"
            onClick={() => {
              setReserveDetails(p => ({
                ...p,
                notes: [...p.notes, { id: p.notes.length + 1, note: '' }]
              }));
            }}
          >
            + Not Ekle
          </button>
        </div>

        {/* Aksiyon Butonları */}
        <div className="button-group">
          <button type="button" className="submit-btn" onClick={handleConvertToRental}>Kiraya Gönder</button>
          <button type="button" className="submit-btn" onClick={handleReserveUpdate}>Rezerveyi Güncelle</button>
          <button type="button" className="end-rental-btn" onClick={() => setShowCancelModal(true)}>
          Rezerveyi İptal Et
          </button>
        </div>
        {showCancelModal && (
  <div className="reserve-edit-modal-backdrop">
    <div className="reserve-edit-modal">
      <h3>Rezervasyonu İptal Et</h3>
      <p>Rezerveyi iptal etmek istediğine emin misin?</p>
      <div className="actions">
        <button
          type="button"
          className="btn cancel"
          onClick={() => setShowCancelModal(false)}
        >
          Vazgeç
        </button>
        <button
          type="button"
          className="btn confirm"
          onClick={() => {
            setShowCancelModal(false);
            handleReserveCancel();
          }}
        >
          Evet, İptal Et
        </button>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default ReserveEdit;
